module.exports = __webpack_public_path__ + "static/img/menu-product-t20.970a878d.png";